import React from 'react';
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import LocationTimeline from "../../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../../components/ServiceCards/ServiceCards";
import SEO from "../../../../utils/SEO";

export default function GibraltarCryptoDLTLicense (){

    return (
        <main className='main'>
            <SEO
                title="Gibraltar Crypto & DLT License | GFSC Regulation "
                description="Get a Gibraltar DLT license for crypto exchanges, wallets, and blockchain platforms. GFSC-regulated framework trusted by global institutions. "
                keywords="Gibraltar crypto license, DLT license Gibraltar, GFSC crypto regulation, crypto exchange license Gibraltar, blockchain license Europe, crypto wallet license Gibraltar, tokenization license, fintech licensing Gibraltar"
                url="/gibraltar-crypto-dlt-license"
            />

            <IntroSection
                title="Gibraltar Crypto & DLT License"
                subtitle="Europe’s First Regulated DLT Jurisdiction"
                description =
                    "
                    <b>Gibraltar</b> is a <b>global pioneer</b> in <b>crypto and blockchain regulation</b>. Its <b>DLT framework</b>, supervised by the <b>Gibraltar Financial Services Commission (GFSC)</b>, provides a <b>clear legal pathway</b> for <b>crypto exchanges</b>, <b>custodians</b>, and <b>blockchain platforms</b>.
                    This <b>regulatory clarity</b> makes <b>Gibraltar</b> one of the <b>most prestigious bases</b> for <b>crypto firms</b>, trusted by <b>banks</b>, <b>payment providers</b>, and <b>institutional investors</b>.
                    "
                badges={
                    [
                        "Crypto Exchanges",
                        "Wallet Providers",
                        "Tokenization",
                        "Blockchain Platforms"
                    ]
                }
                buttonText="Request a Gibraltar Crypto Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../../assets/images/services/gibraltar-crypto-dlt-license-hero.png")}
                imageAlt="Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Gibraltar for Crypto & DLT?'
                        blocks={[
                            {
                                items:
                                    [
                                        {
                                            title: "Tier-1 Recognition",
                                            text: "First EU DLT framework, trusted worldwide."
                                        },
                                        {
                                            title: "Strong Regulator",
                                            text: "GFSC enforces strict AML/KYC & security standards."
                                        },
                                        {
                                            title: "Institutional Confidence",
                                            text: "Banking and PSP access easier with Gibraltar."
                                        },
                                        {
                                            title: "Comprehensive Coverage",
                                            text: "From exchanges to token issuers."
                                        },
                                        {
                                            title: "Crypto-Friendly Tax",
                                            text: "10% corporate tax, no capital gains tax, no VAT."
                                        }
                                    ]

                            }
                        ]}
                    />


                    <InfoBlocks
                        title="Types of DLT & Crypto Licenses in Gibraltar"
                        blocks={[
                            {
                                title: 'DLT Provider License (Exchanges & Wallets)',
                                items:
                                    [
                                        {
                                            text: "For firms using blockchain to store, transfer, or transmit value."
                                        },
                                        {
                                            text: "Covers crypto exchanges, custodians, and wallet providers."
                                        }
                                    ]
                            },
                            {
                                title: "Token Issuer / ICOs / STOs",
                                items:
                                    [
                                        {
                                            text: "Gibraltar provides a framework for Initial Coin Offerings (ICOs) and Security Token Offerings (STOs) under DLT law."
                                        },
                                        {
                                            text: "Requires AML/KYC, disclosures, and investor protections."
                                        }
                                    ]
                            },

                            {
                                title: "Blockchain-Based Payment Firms",
                                items:
                                    [
                                        {
                                            text: "Covers PSPs, EMIs, and fintechs using blockchain for settlement."
                                        },
                                        {
                                            text: "Ideal for hybrid crypto-fiat payment companies."
                                        }
                                    ]
                            },
                        ]}
                    />


                    <LocationTimeline
                        title="Capital & Requirements"
                        item={
                            [
                                {
                                    title: "Capital Requirement",
                                    text: "GBP 100k–250k (depending on risk profile)."
                                },
                                {
                                    title: "Entity",
                                    text: "Gibraltar company required."
                                },
                                {
                                    title: "Resident Presence",
                                    text: "At least 1–2 local directors + compliance officer."
                                },
                                {
                                    title: "Office",
                                    text: "Physical presence in Gibraltar mandatory."
                                },
                                {
                                    title: "Compliance",
                                    text: "AML/KYC, cybersecurity, risk management."
                                },
                                {
                                    title: "Audit",
                                    text: "Annual audits + IT security reviews."
                                }
                            ]
                        }
                    />
                    <ServiceCards
                        title='Benefits of Gibraltar DLT License'
                        services={
                            [
                                {
                                    title: "Prestige",
                                    text: "First Tier-1 DLT regulator in the world."
                                },
                                {
                                    title: "Clarity",
                                    text: "Clear legal framework, unlike SVG or Seychelles."
                                },
                                {
                                    title: "Banking Access",
                                    text: "Better PSP/bank onboarding for licensed entities."
                                },
                                {
                                    title: "Investor Confidence",
                                    text: "Regulated crypto firms attract institutional capital."
                                },
                                {
                                    title: "Gateway to UK & EU",
                                    text: "Strong reputation among regulators."
                                }
                            ]
                        }
                    />

                    <DetailsSection
                        title='Licensing Process'
                        items={
                            [
                                {
                                    title: "Pre-Application Consultation",
                                    text: "Define business model (exchange, wallet, token)."
                                },
                                {
                                    title: "Entity Incorporation",
                                    text: "Register company in Gibraltar."
                                },
                                {
                                    title: "Application Preparation",
                                    text: "AML/KYC, cybersecurity, governance manuals."
                                },
                                {
                                    title: "GFSC Review",
                                    text: "Due diligence on directors, shareholders, IT setup."
                                },
                                {
                                    title: "Approval & Licensing",
                                    text: "Typically 6–9 months."
                                }
                            ]
                        }
                        />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "6–9 months.",
                            },
                            {
                                name: "Setup Costs",
                                description: "from GBP 70,000+.",
                            },
                            {
                                name: "Capital Requirement",
                                description: "GBP 100k–250k depending on activity",
                            },
                            {
                                name: "Annual Costs",
                                price: "GFSC fees, compliance, IT audits",
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {
                                    title: "Specialists",
                                    text: "Specialists in crypto & fintech licensing worldwide."
                                },
                                {
                                    title: "End-to-End Support",
                                    text: "Incorporation, GFSC applications, compliance manuals."
                                },
                                {
                                    title: "Network",
                                    text: "Network of banks, PSPs, and crypto-friendly institutions."
                                },
                                {
                                    title: "Comparative Insights",
                                    text: "Gibraltar vs Malta vs Isle of Man vs Switzerland."
                                },
                                {
                                    title: "Long-Term Support",
                                    text: "Compliance & cybersecurity support."
                                }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA
                        title="Looking for a Tier-1 crypto license?"
                        description="Gibraltar offers the world’s first regulated DLT framework, trusted by banks, regulators, and investors."
                        buttonText="Book a Gibraltar Crypto/DLT Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What is a Gibraltar DLT license?",
        content: [
            { type: "answer", text: "It allows companies to use blockchain for storing/transmitting value (exchanges, wallets, PSPs)." },
        ],
    },
    {
        question: "Why Gibraltar over Malta?",
        content: [
            { type: "answer", text: "Gibraltar was first to regulate DLT, and banks prefer its framework." },
        ],
    },
    {
        question: "How much capital is required?",
        content: [
            { type: "answer", text: "GBP 100k–250k depending on scale and risk." },
        ],
    },
    {
        question: "Can ICOs and STOs be licensed?",
        content: [
            { type: "answer", text: "Yes — Gibraltar regulates token offerings under the DLT regime." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "6–9 months." },
        ],
    },
];

const testimonialsData =
    [
        {
            quote: "Our exchange became fully licensed under Gibraltar’s DLT regime. Offshore Advisory managed the GFSC process smoothly.",
            author: "Alex T.",
            role: "Exchange CEO"
        },
        {
            quote: "We chose Gibraltar for our blockchain payment startup. Offshore Advisory helped with incorporation and compliance.",
            author: "Maria L.",
            role: "FinTech Founder"
        }
    ]
;